import {Button, Col, Nav, Navbar, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import React from "react";
import {Formik} from "formik";

export default function Step2(props){

    function backStep(){
        props.cb(0,props.data)
    }
    function saveStep(values){
        props.data.files.images=values.images;
        props.data.files.template=values.template;
        props.data.files.gold=values.gold;
        props.cb(2,props.data);
    }
    return(
        <>

            <Formik
                initialValues={{ images: props.data.files.images,template: props.data.files.template, gold: props.data.files.gold}}
                validate={values => {
                    const errors = {};
                    if (!values.images) {
                        errors.images = 'Required';
                    }
                    if (!values.template) {
                        errors.template = 'Required';
                    }
                    if (!values.gold) {
                        errors.gold = 'Required';
                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    saveStep(values);
                    setSubmitting(false);
                    // navigate('/case/create/'+module+'/'+caseid+'/step3')
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue
                      /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <Row  style={{  marginTop: "20px"}}>
                            <Navbar bg="light" variant="light">

                                <Nav>
                                    <Button onClick={backStep} variant="secondary" >
                                        Back
                                    </Button>
                                </Nav>
                                <Nav className="m-auto">
                                    <p className="m-auto">1. General Information <span className="m-3">-</span> <b>2. Upload Case Files</b> <span className="m-3">-</span> 3. Additional Information</p>
                                </Nav>
                                <Nav>

                                    <Button type="submit" disabled={isSubmitting} variant="primary" >
                                        Next
                                    </Button>
                                </Nav>
                            </Navbar>
                        </Row>
                        <Row className="mt-5">

                            <h5>
                                Uploading Images
                            </h5>
                            <hr/>
                            <Col lg={6}>
                                <span style={{color: "red"}}>{errors.images && touched.images && errors.images}</span>
                                <Form.Group controlId="formFile" className="mb-3">
                                    <Form.Label>Upload the DICOM images by dragging the file in the box bellow or click on the upload button</Form.Label>
                                    <span style={{color: "green"}}>{props.data.files.images.name ? 'Selected file: '+props.data.files.images.name : ''}</span>
                                    <Form.Control name="images" type="file" onChange={(event) => {
                                        setFieldValue("images", event.currentTarget.files[0]);
                                    }}/>
                                </Form.Group>
                            </Col>


                        </Row>
                        <Row className="mt-5">
                            <h5>
                                Upload Template
                            </h5>
                            <hr/>
                            <Col lg={6}>
                                <span style={{color: "red"}}>{errors.template && touched.template && errors.template}</span>
                                <Form.Group controlId="formFile" className="mb-3">
                                    <Form.Label>Upload the DICOM structures of the template by dragging the file in the box bellow or click on the upload button</Form.Label>
                                    <span style={{color: "green"}}>{props.data.files.template.name ? 'Selected file: '+props.data.files.template.name : ''}</span>
                                    <Form.Control name="template" type="file" onChange={(event) => {
                                        setFieldValue("template", event.currentTarget.files[0]);
                                    }}/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-5">
                            <h5>
                                Upload Gold Standard
                            </h5>
                            <hr/>
                            <Col lg={6}>
                                <span style={{color: "red"}}>{errors.gold && touched.gold && errors.gold}</span>

                                <Form.Group controlId="formFile" className="mb-3">
                                    <Form.Label>Upload the DICOM structures of the gld standard by dragging the file in the box bellow or click on the upload button</Form.Label>
                                    <span style={{color: "green"}}>{props.data.files.gold.name ? 'Selected file: '+props.data.files.gold.name : ''}</span>
                                    <Form.Control name="gold" type="file" onChange={(event) => {
                                        setFieldValue("gold", event.currentTarget.files[0]);
                                    }}/>
                                </Form.Group>
                            </Col>
                        </Row>
                    </form>
                )}
            </Formik>

        </>
    )
}